import {cloneDeep} from 'lodash'
import {ModuleFc} from '@/project'
import {Company, CompaniesState} from './types'

export {CompaniesState}

const initState: CompaniesState = {
  companies: [],
  totalCount: null,
  nextPage: null,
  prevPage: null,
}

const module: ModuleFc<CompaniesState> = (ctx) => ({
  namespaced: true,
  state: cloneDeep(initState),
  actions: {
    async getCompanies(
      {commit},
      payload: {name?: string},
    ) {
      const {name} = payload
      const result = await ctx.$axios({
        url: '/get-companies',
        params: {
          name,
          count: 20,
        },
        method: 'get',
      })
      commit('update', result.data.companies)
      commit('updatePage', result.data)
      return result.data.companies
    },
  },
  mutations: {
    update(state, payload: Company[]) {
      state.companies = payload
    },
    updatePage(state, payload) {
      state.totalCount = payload.totalCount
      state.nextPage = payload.nextPage
      state.prevPage = payload.prevPage
    },
    clear(state) {
      state.companies = []
      state.nextPage = null
      state.prevPage = null
      state.totalCount = null
    },
  },
  getters: {
    noMoreCompany(state) {
      return state.nextPage === 0
    }
  }
})

export default module
